import { createSelector } from 'reselect';

export const selectPositionTemplateDetailState = (state) => state?.positionTemplateDetailState;

export const selectPositionTemplateDetail = createSelector(
  selectPositionTemplateDetailState,
  (s) => s?.positionTemplate || {}
);

export const selectIsPositionTemplateDetailLoading = createSelector(
  selectPositionTemplateDetailState,
  (s) => s?.isLoading || false
);

export const selectHasPositionTemplateDetailError = createSelector(
  selectPositionTemplateDetailState,
  (s) => s?.hasError || false
);
